import { Loader2, Store } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePushContactToSquare } from "@/hooks/useContacts";
import { cn } from "@/lib/utils";

interface PushToSquareButtonProps {
  contactId: string;
  className?: string;
}

/**
 * "Push to Square" action on the contact record (#803). Creates or updates the
 * contact's Square customer via the `square-customers` edge function. Always
 * enabled for a real contact — contacts always have a first name, so a
 * create-by-name is always possible; the only disabled state is while the push
 * is in flight. The Square upsert is idempotent server-side, so a repeat click
 * updates rather than duplicates.
 */
export function PushToSquareButton({ contactId, className }: PushToSquareButtonProps) {
  const push = usePushContactToSquare();

  return (
    <Button
      variant="outline"
      size="sm"
      className={cn("h-7 gap-1 text-xs", className)}
      disabled={push.isPending}
      onClick={() => push.mutate(contactId)}
      aria-label="Push to Square"
    >
      {push.isPending ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Store className="h-3.5 w-3.5" />
      )}
      Push to Square
    </Button>
  );
}
